import produce from 'immer';

import {
	OPEN_CONTEXT_MENU_FULFILLED,
	CLOSE_CONTEXT_MENU_FULFILLED
} from '../constants/contextMenu.actions';

const filtersReducer = produce(
	(draft, action) => {
		switch(action.type) {
			case OPEN_CONTEXT_MENU_FULFILLED: {
				draft.active = action.payload.contextMenu;
				draft.x = action.payload.x;
				draft.y = action.payload.y;
				break;
			}
			case CLOSE_CONTEXT_MENU_FULFILLED: {
				draft.active = '';
				break;
			}
			default: {
				break;
			}
		}
	},
	{
		active: '',
		x: 0,
		y: 0
	}
);

export default filtersReducer;
